import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    // `key` changes on every navigation, even to the identical URL — without it
    // a second click on "/#contact" (after scrolling away) would not re-scroll.
    const { pathname, hash, key } = useLocation();

    useEffect(() => {
        // If there is a hash, scroll to it
        if (hash) {
            // Retry mechanism to handle lazy loaded components
            let retries = 0;
            const maxRetries = 20; // 2 seconds total (20 * 100ms)
            
            const scrollWithRetry = () => {
                const element = document.getElementById(hash.slice(1));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else if (retries < maxRetries) {
                    retries++;
                    setTimeout(scrollWithRetry, 100);
                }
            };

            // Start trying to scroll
            setTimeout(scrollWithRetry, 100);
        } else {
            // If no hash, scroll to top (standard route change behavior)
            window.scrollTo(0, 0);
        }
    }, [pathname, hash, key]);

    return null;
}
